import repository from '../Repository';

  const executiveEndpoint = (brokerType) => ['executive', brokerType].join("/");

  const getExecutiveList = (executiveType) => repository.private().get(`${executiveEndpoint(executiveType)}`);
  const createExecutive = (executiveType, body) => repository.private().post(`${executiveEndpoint(executiveType)}/`, body);
  const getBrokersAsignToExecutive = (executiveId) => repository.private().get(`executive/operative/${executiveId}/assigned-brokers/`);
  export {
    getExecutiveList,
    createExecutive,
    getBrokersAsignToExecutive
  }
  